import React from 'react';
import { useLessonBuilderStore, LessonBlockType } from '../../stores/lessonBuilderStore';
import { Plus } from 'lucide-react';

const blockTypes: Array<{
  type: LessonBlockType;
  title: string;
  description: string;
}> = [
  { type: 'text', title: 'Text', description: 'Headings and paragraphs' },
  { type: 'image', title: 'Image', description: 'Inline or full-bleed images' },
  { type: 'rive', title: 'Rive Animation', description: 'Interactive animations' },
  { type: 'mcq', title: 'MCQ', description: 'Multiple choice questions' },
  { type: 'true_false', title: 'True / False', description: 'Quick correctness checks' },
  { type: 'flip_card_grid', title: 'Flip Cards', description: 'Front-back reveal grid' },
  { type: 'link_preview', title: 'Link Preview', description: 'URL with title/description' },
  { type: 'spacer', title: 'Spacer', description: 'Vertical gap between blocks' },
];

interface BlockLibraryProps {
  onAdd?: () => void;
}

export const BlockLibrary: React.FC<BlockLibraryProps> = ({ onAdd }) => {
  const addBlock = useLessonBuilderStore((s) => s.addBlock);
  const selectedPageId = useLessonBuilderStore((s) => s.selectedPageId);

  const handleAdd = (type: LessonBlockType) => {
    addBlock(type, selectedPageId || undefined);
    onAdd?.();
  };

  return (
    <div className="w-72 flex-shrink-0 border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-2xl shadow-sm p-4 space-y-3">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Blocks</h3>
        <p className="text-sm text-gray-500 dark:text-gray-400">Drag-friendly, mobile-first</p>
      </div>

      <div className="space-y-2">
        {blockTypes.map((block) => (
          <button
            key={block.type}
            onClick={() => handleAdd(block.type)}
            className="w-full text-left border border-gray-200 dark:border-gray-800 rounded-xl px-3 py-3 hover:border-blue-500 hover:bg-blue-50 dark:hover:border-blue-400 dark:hover:bg-blue-950/40 transition flex items-start gap-3"
          >
            <div className="mt-0.5 rounded-lg bg-blue-100 text-blue-700 dark:bg-blue-900/60 dark:text-blue-200 p-1.5">
              <Plus className="w-4 h-4" />
            </div>
            <div>
              <div className="text-sm font-semibold text-gray-900 dark:text-gray-50">{block.title}</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">{block.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
